import { PPC_CLOSE } from '../../shared-components/ClosePage/ClosePageConstants';

export const PAGE_NAME = {
    NEWCUST_PAGE: 'newcust',
    CYCOCORE_PAGE: 'cycocorepage',
    BILLING_PAGE: 'billinginfopage',
    PERSONAL_INFO_PAGE: 'personalinfopage',
    PAYMENT_SECURITY_SUBMIT: 'paymentSecuritySubmit',
    PAYMENT_SECURITY_PAGE: 'paymentSecurityPage',
    TERMS_PAGE: 'termspage',
    DECISION_PAGE: 'decisionpage',
    ERROR_PAGE: 'errorpage',
    INELIGIBLE_PAGE: 'ineligible',
    INVALID_NAME_PAGE: 'updatename',
    CLOSE_PAGE: PPC_CLOSE,
    CYCO_CORE_PAGE: 'cycocorepage',
    CYCO_PAGE: 'cycopage',
    CONTINUE_PAGE: 'continuepage',
    APP_PEND_PAGE: 'documentupload'
};

export const REDIRECT_SUFFIX = {
    PAY_IN_FULL_REDIRECT: 'payInFullNowFlow',
    CANCEL_REDIRECT: 'cancelFlow',
    LOGIN_REDIRECT: 'loginRedirectFlow',
    RETURN_REDIRECT: 'returnFlow'
};
